export function downloadFile(
  data: string | Uint8Array<ArrayBuffer>,
  filename: string,
  mimeType = "application/octet-stream"
) {
  const blob = new Blob([data], { type: mimeType })

  const url = URL.createObjectURL(blob)

  const a = document.createElement("a")
  a.href = url
  a.download = filename

  document.body.appendChild(a)
  a.click()

  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
